import { Button } from '@material-ui/core'
import clsx from 'clsx'
import React from 'react'
import { useStyles } from './Style'
import { SubmitButtonProps } from './Type'
import { renderText } from './Utils'

const FormSubmitButton: React.FC<SubmitButtonProps> = ({
  className,
  updated,
  updatedText,
  error,
  children,
  ...props
}): React.ReactElement => {
  const classes = useStyles()

  return (
    <Button
      variant="contained"
      disableElevation
      className={clsx(
        className,
        classes.button,
        (updated && classes['button-updated']) || (error && classes['button-error'])
      )}
      color="primary"
      {...props}
    >
      {renderText(updated, updatedText, error, children)}
    </Button>
  )
}

export default FormSubmitButton
